import { Button } from 'primereact/button';
import './HorizontalToolbarToggler.css';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function HorizontalToolbarToggler() {
  const { t } = useTranslation();
  const element = useRef();
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };

  const handleToolsVisibility = () => {
    const tools = [
      'FileUploader',
      'StatisticGraphics',
      'StoryTelling',
      'GridLayer',
      'HintWindow',
      'LocateAddress',
      'PrintWindow'
    ];

    tools.forEach((tool) => setToolVisibility(tool));
  };

  const setToolVisibility = (tool) => {
    const el = document.getElementById(tool);
    if (!el) return;

    el.style.zIndex = active ? '2' : '0';
    el.style.opacity = active ? '1' : '0';
    el.style.visibility = active ? 'visible' : 'hidden';
  };

  useEffect(() => {
    handleToolsVisibility();
  }, [active]);

  return (
    <div className="HorizontalToolbarToggler">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('horizontalToolbarToggler.tooltip')}
        title={t('horizontalToolbarToggler.tooltip')}
        ref={element}
        onClick={handleClick}
          icon={active ? 'pi pi-wrench' : 'pi pi-briefcase'} 
      >

      </Button>
    </div>
  );
}

export default HorizontalToolbarToggler;
